export const AthleteData = {
  pricingtype: [
    {
      icon: "layers.svg",
      type: "Basic",
      caption:
        "Officia amet ut incididunt occaecat officia elit in veniam dolore excepteur sunt incididunt in incididunt. Magna sit irure commodo proident ipsum aute aute cillum in labore non adipisicing laboris occaecat. Minim laboris dolor amet officia ad dolore eu mollit adipisicing incididunt officia adipisicing dolore.",
      features: [
        "Athlete can get the detailed profile",
        "Athlete can get the detailed profile",
        "Athlete can get the detailed profile",
        "Athlete can get the detailed profile",
        "Athlete can get the detailed profile",
        "Athlete can get the detailed profile",
        "Athlete can get the detailed profile",
        "Athlete can get the detailed profile"
      ],
      pricelist: ["0"]
    },
    {
      icon: "diamond.svg",
      type: "Premium",
      caption:
        "Anim laboris qui anim Lorem aliquip id reprehenderit voluptate deserunt adipisicing nostrud. Et deserunt aliquip non irure enim aliquip qui nisi aute quis commodo reprehenderit fugiat amet. Tempor enim amet consequat ipsum non velit velit.",
      features: [
        "Athlete can get the detailed profile",
        "Athlete can get the detailed profile",
        "Athlete can get the detailed profile",
        "Athlete can get the detailed profile",
        "Athlete can get the detailed profile",
        "Athlete can get the detailed profile",
        "Athlete can get the detailed profile",
        "Athlete can get the detailed profile"
      ],
      pricelist: ["39", "129", "499"]
    }
  ]
};
export const athleteCompareData = [
  {
    title: "Exposure",
    list: [
      {
        title: "Create a Detailed Profile",
        access: {
          basic: true,
          premium: true
        }
      },
      {
        title: "Appear in searches by Clubs",
        access: {
          basic: true,
          premium: true
        }
      },
      {
        title: "Appear in searches by Colleges",
        access: {
          basic: false,
          premium: true
        }
      },
      {
        title: "Search for and Connect with Clubs Coaches",
        access: {
          basic: false,
          premium: true
        }
      },
      {
        title: "Search for and Connect with College Coaches",
        access: {
          basic: false,
          premium: true
        }
      },
      {
        title: "Add Additional Videos/Live Streams/Pre-Recorded Live Streams",
        access: {
          basic: false,
          premium: true
        }
      }
    ]
  },
  {
    title: "Tracking & Advanced Features",
    list: [
      {
        title: "See when your messages have been viewed",
        access: {
          basic: true,
          premium: true
        }
      },
      {
        title: "See who has viewed your Profile",
        access: {
          basic: false,
          premium: true
        }
      },
      {
        title: "Search for Club and Colleges Teams",
        access: {
          basic: false,
          premium: true
        }
      },
      {
        title: "Manage multiple profiles under one login",
        access: {
          basic: false,
          premium: true
        }
      }
    ]
  },
  {
    title: "Events",
    list: [
      {
        title: "Post your Upcoming Events on your Profile",
        access: {
          basic: false,
          premium: true
        }
      },
      {
        title: "Search for Club Events (Tryouts, Friendlies, and Tournaments)",
        access: {
          basic: false,
          premium: true
        }
      },
      {
        title: "Search for College Events",
        access: {
          basic: false,
          premium: true
        }
      }
    ]
  }
];

export const clubCoachCompareData = [
  {
    title: "Exposure",
    list: [
      {
        title: "Create a Detailed Profile",
        access: {
          basic: true,
          premium: true
        }
      },
      {
        title: "Create a Team Roster",
        access: {
          basic: false,
          premium: true
        }
      },
      {
        title: "Link your Players Profile to your Team Roster",
        access: {
          basic: false,
          premium: true
        }
      },
      {
        title: "Email, Message, and Chat with College Coaches",
        access: {
          basic: false,
          premium: true
        }
      }
    ]
  },
  {
    title: "Tracking & Advanced Features",
    list: [
      {
        title: "Keep track of Profile Views",
        access: {
          basic: true,
          premium: true
        }
      },
      {
        title: "See when your messages have been viewed",
        access: {
          basic: true,
          premium: true
        }
      },
      {
        title: "Add Additional Videos/Live Streams/Pre-Recorded Live Streams",
        access: {
          basic: false,
          premium: true
        }
      },
      {
        title: "Search for and Connect with College Coaches",
        access: {
          basic: false,
          premium: true
        }
      }
    ]
  },
  {
    title: "Events",
    list: [
      {
        title: "Post and Search for Tryouts, Friendlies, and Tournaments",
        access: {
          basic: true,
          premium: true
        }
      },
      {
        title: "Search for College Events",
        access: {
          basic: false,
          premium: true
        }
      }
    ]
  }
];
